import React from 'react';
import { Form, Input } from 'antd';

const { Item } = Form;

const AddressPostalCodeFormItem = () => {
  return (
    <Item
      name="address.postcode"
      label="Code postal"
      wrapperCol={{ span: 15 }}
      labelCol={{ span: 9 }}
    >
      <Input type="number"/>
    </Item>
  );

};

export default AddressPostalCodeFormItem;